module.exports = __webpack_public_path__ + "img/icon_redo.ef3fdb1a.svg";